define('SuiteDynamics.CriteoCustomDataLayerFields.CheckoutInformation',
    [
        'underscore',
        'LiveOrder.Model',
        'SuiteDynamics.CriteoCustomDataLayerFields.EventProcessor'
    ],
    function(
        _,
        LiveOrderModel,
        EventProcessor
    )
{
    'use strict';

    function addCartInformation(eventData, container) {
        if (!eventData.data) {
            eventData.data = {};
        }

        var liveOrderModel = LiveOrderModel.getInstance();
        var cartLines = liveOrderModel.get('lines') || [];
        var products = getProductsInformation(cartLines);
        var currency = getCurrency(container);

        _.extend(eventData.data, {
            products: products,
            currencyCode: currency
        });
    }

    function getProductsInformation(cartLines) {
        return _.map(cartLines.models || [], function(cartLine) {
            var quantity = cartLine.get('quantity');
            var price = cartLine.get('rate');
            var item = cartLine.get('item');
            var id = item && item.get('itemid') || '';

            return {
                id: id,
                sku: id,
                price: price,
                quantity: quantity
            };
        });
    }

    function getCurrency(container) {
        var environment = container.getComponent('Environment');
        var session = environment.getSession();

        return session.currency.code;
    }

    function addDiscountAmount(eventData, container) {
        eventData.data = eventData.data || {};

        var discountAmount = 0;
        var liveOrderModel = LiveOrderModel.getInstance();
        var cartSummary = liveOrderModel.get('summary');

        if (cartSummary && cartSummary.discounttotal) {
            discountAmount = cartSummary.discounttotal;
        } else {
            var cartLines = liveOrderModel.get('lines') ? liveOrderModel.get('lines').models : [];
            discountAmount = _.reduce(cartLines, function(totalAmount, line) {
                return totalAmount + (line.get('discount') || 0);
            }, 0);
        }

        _.extend(eventData.data, {
            discountAmount: parseFloat(discountAmount || 0).toFixed(2)
        });
    }

    EventProcessor.registerEventHandler('proceedToCheckout', addCartInformation);
    EventProcessor.registerEventHandler('cartView', addDiscountAmount);
    EventProcessor.registerEventHandler('transaction', addDiscountAmount);
});
